import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import { getPaymentMode, postPaymentMode } from "../../../services/paymentMode/paymentMode";

const PaymentModeCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [isUpdating, setIsUpdating] = useState(item?.id);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);
  const [gatewayNameData, setGatewayNameData] = useState([]);

  const [paymentModeList, setPaymentModeList] = useState([]);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState([]);
  const [paymentModeError, setPaymentModeError] = useState(false);
  const [selectedPaymentModeList, setSelectedPaymentModeList] = useState([]);
  const [selectedPaymentModeSubscriptionList, setSelectedPaymentModeSubscriptionList] = useState([]);
  const [selectedLocationPaymentMode1, setSelectedLocationPaymentMode1] = useState([])
  const [selectedLocationPaymentMode2, setSelectedLocationPaymentMode2] = useState([])
  const [selectedLocationPaymentMode3, setSelectedLocationPaymentMode3] = useState([])
  const [selectedLocationPaymentMode4, setSelectedLocationPaymentMode4] = useState([])

  const fetchPaymentMode = () => {
    getPaymentMode()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setPaymentModeList(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };



  useEffect(() => {
    fetchPaymentMode();

    if (item) {
      setSelectedPaymentMode(item?.paymentModes)
      setSelectedPaymentModeList(
        item?.paymentModes.map((item, index) => ({
          name: item,
          value: item
        })))
      setSelectedPaymentModeSubscriptionList(
         item?.paymentModes.filter((item) => item !== "USER_ACCOUNT").map((item, index) => ({
          name: item,
          value: item
        })))
      setSelectedLocationPaymentMode1(item?.paymentModeList?.Location1)
      setSelectedLocationPaymentMode2(item?.paymentModeList?.Location2)
      setSelectedLocationPaymentMode3(item?.paymentModeList?.Location3)
    }

  }, []);

  const handlePaymentModeSelectionToggle = (status) => {
    const updatedStatus = [...selectedPaymentMode];


    if (updatedStatus.includes(status)) {
      // Remove status if already selected
      updatedStatus.splice(updatedStatus.indexOf(status), 1);
    } else {
      // Add status if not selected
      updatedStatus.push(status);
    }


    setSelectedPaymentMode(updatedStatus);
    setSelectedPaymentModeList(updatedStatus.map((item, index) => ({
      name: item,
      value: item
    })))
    const filterData = updatedStatus.filter((item) => item !== "USER_ACCOUNT")
    setSelectedPaymentModeSubscriptionList(filterData.map((item, index) => ({
      name: item,
      value: item
    })))
  };


  const handleLocationPaymentMode1 = (item) => {
    setSelectedLocationPaymentMode1(item)
  }
  const handleLocationPaymentMode2 = (item) => {
    setSelectedLocationPaymentMode2(item)
  }
  const handleLocationPaymentMode3 = (item) => {
    setSelectedLocationPaymentMode3(item)
  }
  const handleLocationPaymentMode4 = (item) => {
    setSelectedLocationPaymentMode4(item)
  }

  const isAllSelected = (options, value) =>
    options.length > 0 && options.every((o) => value?.includes(o.value));

  // Select every option in a section, or clear them if all are already selected
  const handleSelectAll = (options, value, onChange) => {
    onChange(isAllSelected(options, value) ? [] : options.map((o) => o.value));
  };

  const handleSelectAllPaymentModes = () => {
    const allSelected =
      paymentModeList.length > 0 &&
      paymentModeList.every((mode) => selectedPaymentMode.includes(mode));
    const updatedStatus = allSelected ? [] : [...paymentModeList];

    setSelectedPaymentMode(updatedStatus);
    setSelectedPaymentModeList(updatedStatus.map((item) => ({
      name: item,
      value: item
    })))
    setSelectedPaymentModeSubscriptionList(
      updatedStatus.filter((item) => item !== "USER_ACCOUNT").map((item) => ({
        name: item,
        value: item
      })))
    setPaymentModeError(false);
  };

  const getCommonPaymentModes = (locationPaymentModes) => {
    const arr1 = selectedPaymentModeList.map(item => item.value);
    const arr2 = locationPaymentModes;

    const set2 = new Set(arr2);

    return arr1.filter(item => set2.has(item));
  };


  const handleSubmit = () => {
    // Reset all previous errors


    let isValid = true;
    if (selectedPaymentMode.length === 0) {
      setPaymentModeError("Please Select Payment Mode");
      isValid = false;
    }


    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        // Call the service function for creating pickup request

        const location1Common = getCommonPaymentModes(selectedLocationPaymentMode1);
        const location2Common = getCommonPaymentModes(selectedLocationPaymentMode2);
        const location3Common = getCommonPaymentModes(selectedLocationPaymentMode3);
        // const location4Common = getCommonPaymentModes(selectedLocationPaymentMode4);

        const data = {
          brandId: brandId,
          paymentModes: selectedPaymentMode.join(","),

          paymentModeList: {
            Location1: location1Common.join(","),
            Location2: location2Common.join(","),
            Location3: location3Common.join(","),
            // Location4: location4Common.join(","),
          }
        };

        postPaymentMode(data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                  setTimeout(() => {
                    navigate("/PaymentMode");
                  }, 1500);
                  setIsButtonPressed(false);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                  setIsButtonPressed(false);
                }
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
            setIsButtonPressed(false);
          });
      }
    } else {
      setIsButtonPressed(false);
    }
  };


  const toggleIn = (list, mode) =>
    list?.includes(mode) ? list.filter((m) => m !== mode) : [...(list || []), mode];

  const sections = [
    {
      title: "Orders",
      subtitle: "Used while placing orders",
      color: "#0E7C6B",
      options: selectedPaymentModeList,
      value: selectedLocationPaymentMode1,
      onChange: handleLocationPaymentMode1,
    },
    {
      title: "Subscription",
      subtitle: "Used for subscription payments",
      color: "#7A4CC2",
      options: selectedPaymentModeSubscriptionList,
      value: selectedLocationPaymentMode2,
      onChange: handleLocationPaymentMode2,
    },
    {
      title: "Store Rider",
      subtitle: "Collected by riders",
      color: "#C26A1B",
      options: selectedPaymentModeList,
      value: selectedLocationPaymentMode3,
      onChange: handleLocationPaymentMode3,
    },
  ];

  const SelectAllButton = ({ allSelected, color, onClick }) => (
    <span
      onClick={onClick}
      className="text-sm font-semibold border-round-2xl px-2 py-1 cursor-pointer select-none"
      style={{ border: `1px solid ${color}`, color }}
    >
      {allSelected ? "Clear All" : "Select All"}
    </span>
  );

  const ModeTag = ({ label, selected, color, onClick }) => (
    <span
      onClick={onClick}
      className="flex align-items-center text-base font-medium border-round-2xl px-3 py-1 cursor-pointer select-none"
      style={{
        background: selected ? color : "#fff",
        color: selected ? "#fff" : "#374151",
        border: `1px solid ${selected ? color : "#D1D5DB"}`,
      }}
    >
      <i className={`pi ${selected ? "pi-check" : "pi-plus"} mr-2 text-sm`}></i>
      {label}
    </span>
  );

  return (
    <div className="flex-1" style={{ background: "#F4F6F8", minHeight: "100vh" }}>
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/PaymentMode")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Payment Mode {item ? "Edit" : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="p-2">
        {/* Step 1: brand payment modes */}
        <div
          className="surface-card border-round-lg shadow-1 px-3 py-2 m-1"
          style={{ borderLeft: "5px solid #1752AA" }}
        >
          <div className="flex align-items-center justify-content-between">
            <div>
              <p className="m-0 text-lg font-bold text-900">1. Select Payment Modes</p>
              <p className="m-0 text-sm text-600">Tap to choose the modes your brand accepts</p>
            </div>
            {paymentModeList?.length > 0 && (
              <SelectAllButton
                color="#1752AA"
                allSelected={paymentModeList.every((mode) => selectedPaymentMode.includes(mode))}
                onClick={handleSelectAllPaymentModes}
              />
            )}
          </div>
          <div className="flex flex-wrap gap-2 mt-2">
            {paymentModeList?.map((mode) => (
              <ModeTag
                key={mode}
                label={mode}
                color="#1752AA"
                selected={selectedPaymentMode.includes(mode)}
                onClick={() => {
                  handlePaymentModeSelectionToggle(mode);
                  setPaymentModeError(false);
                }}
              />
            ))}
          </div>
          {paymentModeError && (
            <p className="m-0 mt-2 text-base" style={{ color: "#DC2626" }}>
              {paymentModeError}
            </p>
          )}
        </div>

        {/* Step 2: where each mode can be used */}
        <p className="m-0 mt-3 mb-1 mx-1 text-base font-semibold text-700">
          2. Choose where each mode can be used
        </p>
        <div className="grid m-0">
          {sections.map(({ title, subtitle, color, options, value, onChange }) => (
            <div key={title} className="col-12 md:col-4 p-1">
              <div
                className="h-full surface-card border-round-lg shadow-1 px-3 py-2"
                style={{ borderLeft: `5px solid ${color}` }}
              >
                <div className="flex align-items-center justify-content-between">
                  <div>
                    <p className="m-0 text-lg font-bold text-900">{title}</p>
                    <p className="m-0 text-sm text-600">{subtitle}</p>
                  </div>
                  <div className="flex align-items-center gap-2">
                    {options.length > 0 && (
                      <SelectAllButton
                        color={color}
                        allSelected={isAllSelected(options, value)}
                        onClick={() => handleSelectAll(options, value, onChange)}
                      />
                    )}
                    <span
                      className="text-base font-bold border-round-2xl px-2"
                      style={{ background: `${color}1A`, color }}
                    >
                      {options.filter((o) => value?.includes(o.value)).length}
                    </span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-2">
                  {options.length > 0 ? (
                    options.map((o) => (
                      <ModeTag
                        key={o.value}
                        label={o.name}
                        color={color}
                        selected={value?.includes(o.value)}
                        onClick={() => onChange(toggleIn(value, o.value))}
                      />
                    ))
                  ) : (
                    <span className="text-base text-500">Select payment modes above first</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <Button
          className="mt-3 mx-1 border-round-xl"
          style={{ width: "calc(100% - 0.5rem)" }}
          onClick={handleSubmit}
          disabled={isButtonPressed}
        >
          <p className="m-0 w-full text-xl font-semibold flex justify-content-center">
            {isButtonPressed ? "Saving..." : item ? "Update" : "Save"}
          </p>
        </Button>
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PaymentModeCreate;
